import { convertFormDataToUrlSearchParams } from '@lib/utils/url'
import { getConfig } from 'src/config'

const config = getConfig()

export const sendWithRecaptcha = async (submitUrl: string, recaptchaToken: string | undefined, formData: FormData) => {
  return fetch(`${config.api.facadeServer}/api/recaptcha`, {
    method: 'post',
    mode: 'no-cors',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      submitUrl,
      recaptchaToken,
      formData: convertFormDataToUrlSearchParams(formData).toString(),
    }),
  })
}
